const ACTION_ORDER = "cacActionOrder";
const ADVOCATE_COOKIE_INFO = "advocateCookieInfo";
const ADVOCATE_RECORD = "advocateRecord";
const ADVOCATE_PAYLOAD = "advocatePayload";
const ADVOCATE_SHORTURL_ID = "advocateShortUrlId";
const BANNER_IMAGE = "contentPageBackgroundImage";
const BANNER_IMAGE_ALT_TEXT = "contentPageBackgroundImageAltText";
const BANNER_TEXT_COLOR = "cacBannerTextColor";
const BROADCAST_DIMENSIONS = "broadcastDimensions";
const CALENDAR_DATES = "calendarDates";
const CAMPAIGN_DESIGN_COLORS = "campaignDesignColors";
const CANDIDATE_PREVIEWS = "candidatePreviews";
const CANDIDATE_PREVIEWS_ALL = "candidatePreviewsAll";
const CANDIDATE_PROFILES = "candidateProfiles";
const CURRENT_CANDIDATE_BREADCRUMB = "currentCandidateBreadcrumb";
const CURRENT_CANDIDATE_DATA = "currentCandidateData";
const CURRENT_CANDIDATE_ID = "currentCandidateId";
const CURRENT_OFFICIAL_BREADCRUMB = "currentOfficialBreadcrumb";
const CURRENT_OFFICIAL_DATA = "currentOfficialData";
const CURRENT_OFFICIAL_ID = "currentOfficialId";
const CUSTOM_FIELDS = "customFields";
const ELECTED_OFFICIAL_PREVIEWS = "electedOfficialPreviews";
const ELECTED_OFFICIAL_PREVIEWS_ALL = "allElectedOfficialPreviews";
const ELECTED_OFFICIAL_PROFILES = "electedOfficialProfiles";
const ERROR = "error";
const FEATURED_CONTENT = "cacFeaturedContent";
const FOOTER_CONTACT_INFO_CONTENT = "cacFooterContactInfoContent";
const FORM_FIELDS = "formFields";
const FORM_VALUES = "formValues";
const HAS_ADVOCATE = "hasAdvocate";
const HAS_FEATURED_CONTENT = "hasFeaturedContent";
const IS_MOBILE = "isMobile";
const IS_WIDGET = "isWidget";
const LOGO_URL = "campaignLogo";
const LOGO_ALT = "campaignLogoAltText";
const OPTIONAL_FIELDS = "optionalFields";
const P2A_SOURCE_ID = "p2aSourceId";
const PRIVACY_POLICY_URL = "privacyPolicyUrl";
const REGISTRATION_COMPLETED = "registrationCompleted";
const SCOPE_CAC = "cac";
const SCOPE_CAMPAIGN = "campaign";
const SCOPE_FORMS = "forms";
const SCOPE_OFFICIALS = "officials";
const SELECTED_LANGUAGE = "selectedLanguage";
const SHOW_FOOTER_CONTACT_INFO = "cacShowFooterContactInfo";
const SHOW_SUBSCRIBE_EMAIL = "cacShowSubscribeEmail";
const SHOW_SUBSCRIBE_SMS = "cacShowSubscribeSMS";
const STARTED_FILLING_FORM = "started";
const VALIDATION_ERROR_MSG = "validationErrorMsg";
const VOTER_INFORMATION = "voterInformation";

export default {
  ACTION_ORDER,
  ADVOCATE_COOKIE_INFO,
  ADVOCATE_RECORD,
  ADVOCATE_PAYLOAD,
  ADVOCATE_SHORTURL_ID,
  BANNER_IMAGE,
  BANNER_IMAGE_ALT_TEXT,
  BANNER_TEXT_COLOR,
  BROADCAST_DIMENSIONS,
  CALENDAR_DATES,
  CAMPAIGN_DESIGN_COLORS,
  CANDIDATE_PREVIEWS,
  CANDIDATE_PREVIEWS_ALL,
  CANDIDATE_PROFILES,
  CURRENT_CANDIDATE_BREADCRUMB,
  CURRENT_CANDIDATE_DATA,
  CURRENT_CANDIDATE_ID,
  CURRENT_OFFICIAL_BREADCRUMB,
  CURRENT_OFFICIAL_DATA,
  CURRENT_OFFICIAL_ID,
  CUSTOM_FIELDS,
  ELECTED_OFFICIAL_PREVIEWS,
  ELECTED_OFFICIAL_PREVIEWS_ALL,
  ELECTED_OFFICIAL_PROFILES,
  ERROR,
  FEATURED_CONTENT,
  FOOTER_CONTACT_INFO_CONTENT,
  FORM_FIELDS,
  FORM_VALUES,
  HAS_ADVOCATE,
  HAS_FEATURED_CONTENT,
  IS_MOBILE,
  IS_WIDGET,
  LOGO_URL,
  LOGO_ALT,
  OPTIONAL_FIELDS,
  P2A_SOURCE_ID,
  PRIVACY_POLICY_URL,
  REGISTRATION_COMPLETED,
  SCOPE_CAC,
  SCOPE_OFFICIALS,
  SCOPE_CAMPAIGN,
  SCOPE_FORMS,
  SELECTED_LANGUAGE,
  SHOW_FOOTER_CONTACT_INFO,
  SHOW_SUBSCRIBE_EMAIL,
  SHOW_SUBSCRIBE_SMS,
  STARTED_FILLING_FORM,
  VALIDATION_ERROR_MSG,
  VOTER_INFORMATION
};
